var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#75B263"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.833H23.625",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0625 9.77118C20.3774 9.45623 20.8046 9.2793 21.25 9.2793C21.4705 9.2793 21.6889 9.32274 21.8927 9.40713C22.0964 9.49153 22.2816 9.61523 22.4375 9.77118C22.5934 9.92712 22.7171 10.1123 22.8015 10.316C22.8859 10.5198 22.9294 10.7381 22.9294 10.9587C22.9294 11.1792 22.8859 11.3976 22.8015 11.6013C22.7171 11.8051 22.5934 11.9902 22.4375 12.1462L12.5417 22.042L9.375 22.8337L10.1667 19.667L20.0625 9.77118Z",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadEdit);
export default __webpack_public_path__ + "static/media/Upload-Edit.04c5886add9f8565cc064ec47e7a9e91.svg";
export { ForwardRef as ReactComponent };